export default class PaginationRequest {
  page: number;
  limit: number;

  constructor(paginationRequest: PaginationRequest) {
    this.page = paginationRequest.page || 1;
    this.limit = paginationRequest.limit || 10;
  }
}
